import React, { useEffect, useCallback } from 'react';

const ConfirmDialog = ({ open, title, message, onConfirm, onCancel, okOnly = false }) => {
    /// Close on ESC
    const handleKey = useCallback((e) => {
        if (!open) return;
        if (e.key === 'Escape') {
            e.stopPropagation();
            if (onCancel) onCancel();
        }
    }, [open, onCancel]);

    useEffect(() => {
        if (!open) return;
        window.addEventListener('keydown', handleKey);
        return () => window.removeEventListener('keydown', handleKey);
    }, [open, handleKey]);

    if (!open) return null;
    return (
        <div
            className="modal-overlay"
            onClick={onCancel} // backdrop click closes
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                background: 'rgba(0,0,0,0.35)',
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <div
                className="modal-container"
                onClick={(e) => e.stopPropagation()} // prevent backdrop close when clicking content
                style={{
                    background: '#fff',
                    borderRadius: 10,
                    boxShadow: '0 8px 32px rgba(0,0,0,0.18), 0 1.5px 4px rgba(0,0,0,0.12)',
                    padding: '32px 28px 24px 28px',
                    minWidth: 340,
                    maxWidth: 420,
                    border: '1px solid #e0e0e0',
                    fontFamily: 'inherit'
                }}
            >
                {title && (
                    <div style={{
                        background: '#0d6efd',
                        color: '#fff',
                        margin: '-32px -28px 20px -28px',
                        padding: '14px 28px',
                        borderRadius: '10px 10px 0 0',
                        fontSize: 18,
                        fontWeight: 600,
                        borderBottom: '1px solid #0a58ca'
                    }}>
                        {title}
                    </div>
                )}
                <div style={{
                    margin: '0 0 28px 0',
                    color: '#444',
                    fontSize: 15,
                    lineHeight: 1.6
                }}>
                    {message}
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
                    {okOnly ? (
                        <button
                            onClick={onCancel}
                            style={{
                                padding: '7px 20px',
                                background: '#007bff',
                                color: '#fff',
                                border: 'none',
                                borderRadius: 5,
                                fontSize: 15,
                                fontWeight: 500,
                                cursor: 'pointer',
                                boxShadow: '0 1px 2px rgba(0,0,0,0.07)'
                            }}
                        >
                            OK
                        </button>
                    ) : (
                        <>
                            <button
                                onClick={onConfirm}
                                style={{
                                    padding: '7px 20px',
                                    background: '#007bff',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: 5,
                                    fontSize: 15,
                                    fontWeight: 500,
                                    cursor: 'pointer',
                                    boxShadow: '0 1px 2px rgba(0,0,0,0.07)'
                                }}
                            >
                                Yes
                            </button>
                            <button
                                onClick={onCancel}
                                style={{
                                    padding: '7px 20px',
                                    background: '#dc3545',
                                    color: '#fff',
                                    border: '1px solid #dc3545',
                                    borderRadius: 5,
                                    fontSize: 15,
                                    cursor: 'pointer',
                                    transition: 'background 0.2s'
                                }}
                            >
                                Cancel
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ConfirmDialog;